import './categoryBarItem.css';

var styles = {"item":"item__2fwfb","icon":"icon__Xgo-Z","title":"title__2ip64","itemButton":"itemButton__vY7ws","active":"active__2VKCk","itemCategoryPage":"itemCategoryPage__1mE3Z","GGSpark1":"GGSpark1__1Q6LT","GGSpark2":"GGSpark2__2U5x7","GGSpark3":"GGSpark3__3IB4f"};

export { styles as default };
